
.gamepage {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  color: var(--color-black-1);
}
